import { render } from "./Perfrom.vue?vue&type=template&id=2b276110"
import script from "./Perfrom.vue?vue&type=script&lang=js"
export * from "./Perfrom.vue?vue&type=script&lang=js"

import "./Perfrom.vue?vue&type=style&index=0&id=2b276110&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__